export const getOrganizationChartIS = {
	data: undefined,
	loading: false,
	error: null,
	errorShow: false,
	isLoad: false,
};
